import VoucherItem from '@/components/VoucherItem'
import type { VoucherItem as CouponType } from '@/types'
import { useMemo } from 'react'

export interface ProductVoucherProps {
  coupons: CouponType[]
  className?: string
}

const ProductVoucher = ({ coupons, className = '' }: ProductVoucherProps) => {
  const voucherDisplay = useMemo(
    () => coupons?.sort((a, b) => b.updatedAt - a.updatedAt)?.[0],
    [coupons]
  )

  if (!voucherDisplay)
    return <div className={`min-h-[40px] w-full px-2 py-1 ${className}`} />

  return (
    <VoucherItem
      data={voucherDisplay}
      className={`h-10 px-2 text-xs ${className}`}
    />
  )
}

export default ProductVoucher
